import { IDeviceUpdateProviderService } from 'lavva.exalushome/build/js/Services/Updates/UpdateProviderServices/IDeviceUpdateProviderService'
import { ExtensionInfo } from 'lavva.exalushome/build/js/Services/Controller/ControllerExtensionsService';
import { SoftwareRuntimeInfo, UpdatesProvider } from 'lavva.exalushome/build/js/Services/Updates/UpdatesProvider'
import { Api } from 'lavva.exalushome';
import { LoggerService } from 'lavva.exalushome/build/js/Services/Logging/LoggerService';
import { ILoggerService } from 'lavva.exalushome/build/js/Services/Logging/ILoggerService';
import { DataFrame, Method, Status } from 'lavva.exalushome/build/js/DataFrame';
import { IExalusConnectionService } from 'lavva.exalushome/build/js/Services/IExalusConnectionService';
import { ExalusConnectionService } from 'lavva.exalushome/build/js/Services/ExalusConnectionService';
import { IUpdatesProvider, ProviderType, Update, UpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesProvider'
import { ResponseResult } from 'lavva.exalushome/build/js/Services/FieldChangeResult';
import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { ExtaLifeService } from '../../ExtaLife';
import { BulkUpdateDeviceStatus, BulkUpdateResult, IUpdatesService, UpdateAction, UpdateErrorCode, UpdateProgress } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { UpdateProgressInfo, UpdateStatus } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService'
import { Progress as ProgresPercent } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService'
import { ICustomUpdateActions } from 'lavva.exalushome/build/js/Services/Updates/CustomUpdateActions/ICustomUpdateActions'
import { IDevicesService } from 'lavva.exalushome/build/js/Services/Devices/IDevicesService';
import { DevicesService } from 'lavva.exalushome/build/js/Services/Devices/DevicesService';
import { IControllerModulesUpdatesProviderService } from 'lavva.exalushome/build/js/Services/Updates/UpdateProviderServices/IControllerModulesUpdatesProviderService';
import { UpdatesService } from 'lavva.exalushome/build/js/Services/Updates/UpdatesService';
import { ControllerUpdateType, ControllerVersion, IDeviceUpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdateInfo';
import { ParseObjToMap } from 'lavva.exalushome/build/js/Helpers';

export class ExtaLifeDevicesUpdatesProvider implements IDeviceUpdateProviderService {
    public static readonly ProviderName = "ExtaLifeDeviceUpdateProvider";

    private _apiVersion: string;
    private _extenstionVersion: string;
    private _protocolExtGuid: string;
    private _runtimeInfo: SoftwareRuntimeInfo;
    private _logger: ILoggerService;
    private _connection: IExalusConnectionService;
    private _devices: IDevicesService;
    private _updateProvider: IUpdatesProvider;


    constructor(extInfo: ExtensionInfo, runtimeInfo: SoftwareRuntimeInfo) {
        this._apiVersion = extInfo.APIVersion;
        this._extenstionVersion = extInfo.ExtensionVersion;
        this._protocolExtGuid = extInfo.ExtensionGuid;
        this._runtimeInfo = runtimeInfo;

        this._logger = Api.Get<ILoggerService>(LoggerService.ServiceName);
        this._connection = Api.Get<IExalusConnectionService>(ExalusConnectionService.ServiceName);
        this._devices = Api.Get<IDevicesService>(DevicesService.ServiceName);
        this._updateProvider = Api.Get<IUpdatesProvider>(UpdatesProvider.ServiceName);
    }
    get ProtocolGuid(): string {
        return ExtaLifeService.ExtaLifeProtocolGuid;
    }

    get ExtensionGuid(): string {
        return this._protocolExtGuid;
    }

    get AvailableApiVersion(): string {
        return this._apiVersion;
    }

    get AvailableExtensionVersion(): string {
        return this._extenstionVersion;
    }

    get ProviderType(): ProviderType {
        return ProviderType.Device;
    }

    GetUpdateProviderName(): string {
        return `${ExtaLifeDevicesUpdatesProvider.ProviderName}_${this._apiVersion}_${this._extenstionVersion}`;
    }

    async GetAvailableUpdateAsync(device: IDevice): Promise<UpdateInfo | ResponseResult<UpdateErrorCode>> {
        try {
            if (device.ProtocolGuid != ExtaLifeService.ExtaLifeProtocolGuid) {
                this._logger.Debug(`Cannot get available updates! Device ${device.Name} does not support the ExtaLife protocol.`);
                return new ResponseResult(UpdateErrorCode.UnsupportedDevice, `Cannot get available updates! Device ${device.Name} does not support the ExtaLife protocol.`)
            }

            if (parseFloat(this._apiVersion) < 2.0) {
                this._logger.Debug(`Cannot get available updates! Unsupported API version: ${this._apiVersion}`);
                return new ResponseResult(UpdateErrorCode.UnsupportedApiVersion, `Cannot get available updates! Unsupported API version: ${this._apiVersion}`);
            }
            else if (parseFloat(this._apiVersion) < 3.0) {
                const currentDeviceFv = await this.GetFirmwareVersionAsync(device);

                if ((currentDeviceFv as ResponseResult<UpdateErrorCode>).Type != null) {
                    this._logger.Debug(`Cannot get available updates! Error: ${(currentDeviceFv as ResponseResult<UpdateErrorCode>).Type}`);
                    return currentDeviceFv as ResponseResult<any>;
                }

                let upd = Api.Get<IUpdatesService>(UpdatesService.ServiceName);
                let branch = await upd.GetControllerUpdateBranchAsync();
                let variant = "lavva";

                if (document.location.hostname.endsWith("tr7.pl"))
                    variant = "portos";

                const url = `https://exalus-updates.tr7.pl/firmware/${variant}/${branch}/${device.ModelGuid}/update.json`;
                let fv = currentDeviceFv as FirmwareVersion;
                let fvs = `${fv.Major}.${fv.Minor}.${fv.Revision}.${fv.Build}`;

                try {
                    this._logger.Debug(`Checking for firmware update, device: ${device.ModelGuid} name: ${device.Name} firmware ver.: ${JSON.stringify(fv)} ver: ${fvs} \n url: ${url} protocol: ${document.location.protocol}`);
                    const response = await fetch(url);
                    let updateData;
                    let updateInfo = new UpdateInfo();

                    switch (response.status) {
                        case 200:
                            if (response.body != null) {
                                updateData = await response.json() as FirmwareUpdate;
                                this._logger.Debug(`Recived update data: ${JSON.stringify(updateData)}`);
                            }
                            else {
                                this._logger.Warning(`Cannot get updates! Response body is null.`)
                                return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot get updates! Response body is null.`);
                            }
                            break;
                        case 404:
                            this._logger.Debug(`Updates not found, device ${device.Name} is already up-to-date.`);
                            return new ResponseResult(UpdateErrorCode.DeviceIsUpToDate, `Updates not found, device ${device.Name} is already up-to-date.`);
                        default:
                            this._logger.Debug(`Cannot get updates! Response status code does not indicate success. Status: ${response.status}`);
                            return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Response status code does not indicate success. Status: ${response.status}`);
                    }

                    if (updateData != null) {
                        if (updateData.DownloadUri.startsWith("/"))
                            updateData.DownloadUri = `https://exalus-updates.tr7.pl${updateData.DownloadUri}`;

                        let minControllerSoftwareVer = updateData.RequiredMinimumControllerSoftwareVersion;
                        let minContrSoftVerAsString = `${minControllerSoftwareVer.Major}.${minControllerSoftwareVer.Minor}.${minControllerSoftwareVer.Revision}.${minControllerSoftwareVer.Build}`;
                        let currentControllerSoftwareVersion = await upd.CheckControllerVersionAsync();
                        this._logger.Debug(`Checking for controller software version. Required: ${minContrSoftVerAsString}`);

                        if (currentControllerSoftwareVersion instanceof ResponseResult)
                            return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Failed to get controller software version. Error: ${JSON.stringify((currentControllerSoftwareVersion as ResponseResult<UpdateErrorCode>))}`);
                        else {
                            let v = (currentControllerSoftwareVersion as ControllerVersion[]).first(v => v.Type == ControllerUpdateType.SoftwareUpdate);

                            if (v == null) {
                                this._logger.Debug(`Cannot get controller software version. Controller software version not found.`);
                                return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Failed to get controller software version. Error: Controller software version not found.`);
                            }
                            else
                                this._logger.Debug(`Current controller software version: ${v.Version}`);

                            let ve = new FirmwareVersion();
                            let ver = v.Version.split(".");
                            ve.Major = parseInt(ver[0]);
                            ve.Minor = parseInt(ver[1]);
                            ve.Revision = parseInt(ver[2]);
                            ve.Build = parseInt(ver[3]);

                            if (ve.Revision < minControllerSoftwareVer.Revision || (ve.Revision == minControllerSoftwareVer.Revision && ve.Build <= minControllerSoftwareVer.Build)) {
                                this._logger.Debug(`Cannot get update! Required minimum controller software version is higher than current. Required: ${minContrSoftVerAsString} Current: ${v.Version}`);
                                return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot get update! Required minimum controller software version is higher than current. Required: ${minContrSoftVerAsString} Current: ${v.Version}`);
                            }
                        }

                        let currentDeviceFirmwareVersion = `${(currentDeviceFv as FirmwareVersion).Major}.${(currentDeviceFv as FirmwareVersion).Minor}.${(currentDeviceFv as FirmwareVersion).Revision}.${(currentDeviceFv as FirmwareVersion).Build}`;
                        let updateFirmwareversionString = `${updateData.Version.Major}.${updateData.Version.Minor}.${updateData.Version.Revision}.${updateData.Version.Build}`;

                        if (currentDeviceFirmwareVersion == updateFirmwareversionString) {
                            this._logger.Debug(`Device ${device.Name} is already up-to-date. Version: ${currentDeviceFirmwareVersion}`);
                            return new ResponseResult(UpdateErrorCode.DeviceIsUpToDate, `Device ${device.Name} is already up-to-date. Version: ${currentDeviceFirmwareVersion}`);
                        }

                        updateInfo.CurrentResourceVersion = currentDeviceFirmwareVersion;
                        updateInfo.Update = new Update();
                        updateInfo.Update.UpdateGuid = updateData.UpdateGuid;
                        updateInfo.Update.Channel = updateData.Branch;
                        updateInfo.Update.Version = updateFirmwareversionString;
                        updateInfo.Update.DownloadUri = updateData.DownloadUri;
                        updateInfo.Update.Name = updateData.Name["en-US"] ?? updateData.Name["pl-PL"] ?? "Unknown";
                        updateInfo.Update.Description = updateData.Description["en-US"] ?? updateData.Description["pl-PL"] ?? "Unknown";
                        updateInfo.Update.ResourceGuid = device.Guid;
                        updateInfo.UpdatedResourceName = device.Name;
                        updateInfo.UpdateDescription = new Map(Object.entries(updateData.Description));

                        return updateInfo;
                    }
                    else {
                        this._logger.Warning(`Cannot get Update Data from response. Response status: ${response.status}`);
                        return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot get Update Data from response. Status: ${response.status}`);
                    }

                } catch (error) {
                    this._logger.Warning(`Cannot get available updates! Error: ${error}`);
                    return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Request failed. Error: ${error}`);
                }
            }
            else {
                this._logger.Warning(`Cannot get available updates! Unsupported API version: ${this._apiVersion}`);
                return new ResponseResult(UpdateErrorCode.UnsupportedApiVersion, `Cannot get available updates! Unsupported API version: ${this._apiVersion}`);
            }
        }
        catch (error) {
            this._logger.Warning(`Cannot get available updates! Error: ${error}`);
            return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot get available updates! Error: ${error}`);
        }
    }


    async CheckUpdateBulkAsync(reloadCache?: boolean): Promise<UpdateInfo[] | ResponseResult<UpdateErrorCode>> {
        const devs = await Api.Get<IDevicesService>(DevicesService.ServiceName).GetDevicesAsync();
        const devsNum = devs.where(d => d.ProtocolGuid == ExtaLifeService.ExtaLifeProtocolGuid).count();

        const result = await this._connection.SendAndWaitForResponseAsync<UpdateInfoResponse[]>(new CheckUpdatesRequest(reloadCache), devsNum * 1_500, false);

        if (result == null || result.Status == null)
            return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot check updates! Response does not contain data.`);

        if (result.Status != Status.OK)
            return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot check updates! Controler responded with status ${result.Status}.`);

        if (result.Data == null)
            return new ResponseResult(UpdateErrorCode.CannotGetUpdates, `Cannot check updates! Response does not contain data.`);

        return result.Data.map(d => {
            d.FirmwareUpdate.Name = new Map(Object.entries(d.FirmwareUpdate.Name));

            const updateInfo = new UpdateInfo();
            updateInfo.CurrentResourceVersion = d.CurrentVersion;
            updateInfo.UpdatedResourceName = devs.first(a => a.Guid == d.DeviceGuid).Name ?? "Unknown";
            updateInfo.UpdateDescription = new Map(Object.entries(d.FirmwareUpdate.Description));
            updateInfo.Update = new Update();
            updateInfo.Update.Channel = d.FirmwareUpdate.Branch;
            updateInfo.Update.DownloadUri = d.FirmwareUpdate.DownloadUri;
            updateInfo.Update.CurrentVersion = d.CurrentVersion;
            updateInfo.Update.Version = d.NewVersion;
            updateInfo.Update.Name = d.FirmwareUpdate.Name.get("en-US") ?? d.FirmwareUpdate.Name.get("pl-PL") ?? "Unknown";
            updateInfo.Update.ResourceGuid = d.DeviceGuid;
            updateInfo.Update.UpdateGuid = d.FirmwareUpdate.UpdateGuid;
            return updateInfo;
        });
    }

    async GetSoftwareVersionAsync(device: IDevice): Promise<string | ResponseResult<UpdateErrorCode>> {
        if (device.ProtocolGuid != ExtaLifeService.ExtaLifeProtocolGuid)
            return new ResponseResult(UpdateErrorCode.UnsupportedDevice, `Cannot get available updates! Device ${device.Name} does not support the ExtaLife protocol.`)

        const result = await this.GetFirmwareVersionAsync(device);

        if ((result as ResponseResult<any>).Type != null)
            return result as ResponseResult<any>;

        return `${(result as FirmwareVersion).Major}.${(result as FirmwareVersion).Minor}.${(result as FirmwareVersion).Revision}.${(result as FirmwareVersion).Build}`;
    }

    protected async GetFirmwareVersionAsync(device: IDevice): Promise<FirmwareVersion | ResponseResult<UpdateErrorCode>> {
        const result = await this._connection?.SendAndWaitForResponseAsync<FirmwareVersion>(new GetFirmwareVersion(device.Guid), 12000, false);

        if (result == null || result.Status == null)
            return new ResponseResult(UpdateErrorCode.CannotGetFirmwareVersion, `Cannot get firmware version! Response does not contain data.`);

        if (result.Status != Status.OK)
            return new ResponseResult(UpdateErrorCode.CannotGetFirmwareVersion, `Cannot get firmware version! Controler responded with status ${result.Status}.`);

        if (result.Data == null)
            return new ResponseResult(UpdateErrorCode.CannotGetFirmwareVersion, `Cannot get firmware version! Response does not contain data.`);

        const fv = new FirmwareVersion();
        fv.Major = result.Data.Major;
        fv.Minor = result.Data.Minor;
        fv.Revision = result.Data.Revision;
        fv.Build = result.Data.Build;

        return fv;
    }

    async InstallUpdateAsync<T extends ICustomUpdateActions>(update: UpdateInfo, updateProgress: UpdateProgress, updateAction?: UpdateAction<T> | undefined, force: boolean = false): Promise<Status.OK | ResponseResult<UpdateErrorCode>> {
        if (updateAction != null)
            return new ResponseResult(UpdateErrorCode.UpdateActionsNotSupported, `Update service for given resource: ${update.UpdatedResourceName} does not support custom update actions.`);

        if (parseFloat(this._apiVersion) < 2.0) {
            return new ResponseResult(UpdateErrorCode.UnsupportedApiVersion, `Cannot install update! Unsupported API version: ${this._apiVersion}`);
        }
        else if (parseFloat(this._apiVersion) < 3.0) {

            if ((await this._devices.GetDevicesAsync()).find(d => d.ModelGuid == "952ddc14-76c4-4f47-b0bc-5d106c1f9b02") != null) {
                if (!force)
                    return new ResponseResult(UpdateErrorCode.RetransmitterFound, `Cannot install update! Retransmitter found! Use force option to install update if you are sure what you are doing.`);
            }

            var extaLifeProvider = (await this._updateProvider.GetUpdatesProvidersByProtocolAsync<IControllerModulesUpdatesProviderService>(ExtaLifeService.ExtaLifeProtocolGuid, ProviderType.Controller)).firstOrDefault();
            var hwInfo = await this._updateProvider.GetHardwareInfoAsync();

            //For new hardware version (cpu IMX6UL) we need to check if radio version is supported due to radio bug.
            if (hwInfo.GetAvailableHardware.find(h => h.DevicePath === "/proc")?.DisplayName === "IMX6UL") {
                if (parseFloat(await extaLifeProvider?.GetCurrentRadioVersionAsync() ?? '1.0') < 1.4) {
                    return new ResponseResult(UpdateErrorCode.ProtocolRadioUnsupported, `Cannot install update! Unsupported API version: ${this._apiVersion}`);
                }
            }

            const requestData = new DeviceFirmware(update.Update.ResourceGuid, update.Update.DownloadUri);

            try {
                await this._connection?.SendAndHandleResponseAsync<Progress>(new UpgradeFirmwareVersion(requestData), 60000, (resp) => {

                    const progressInfo = new UpdateProgressInfo();
                    progressInfo.UpdatedResourceName = new Map<string, string>([["pl-PL", update.UpdatedResourceName], ["en-US", update.UpdatedResourceName]]);

                    switch (resp.Status) {
                        case Status.MultiDataResponseStart:
                            progressInfo.Status = UpdateStatus.PreparingForUpgrade;
                            break;
                        case Status.MultiDataResponse:
                            if (resp.Data == null) {
                                this._logger.Warning(ExtaLifeDevicesUpdatesProvider.ProviderName, `Recived update response without data! URI: ${update.Update.DownloadUri}`);
                                return;
                            }

                            progressInfo.Percentage = resp.Data.CurrentProgress;
                            progressInfo.PercentageTotal = progressInfo.Percentage;

                            switch (resp.Data?.FirmwareUpgradeStatus) {
                                case FirmwareUpgradeStatus.Error:
                                    progressInfo.Status = UpdateStatus.InstallationError;
                                    break;
                                case FirmwareUpgradeStatus.OK:
                                    if (progressInfo.Percentage == 100)
                                        progressInfo.Status = UpdateStatus.Upgraded;
                                    else
                                        progressInfo.Status = UpdateStatus.OK;
                                    break;
                                case FirmwareUpgradeStatus.PreparingForUpgrade:
                                    progressInfo.Status = UpdateStatus.PreparingForUpgrade;
                                    break;
                                case FirmwareUpgradeStatus.Upgraded:
                                    progressInfo.Status = UpdateStatus.Upgraded;
                                    break;
                                default:
                                    progressInfo.Status = UpdateStatus.Upgrading;
                            }
                            break;
                        case Status.MultiDataResponseStop:
                            if (resp.Data?.CurrentProgress == 100)
                                progressInfo.Status = UpdateStatus.Upgraded;
                            else
                                progressInfo.Status = UpdateStatus.Error;
                    }

                    this._logger.Debug(ExtaLifeDevicesUpdatesProvider.ProviderName, `Recived update progress response, percentage: ${progressInfo.Percentage}, status: ${progressInfo.Status}, resource name: ${update.UpdatedResourceName}`);
                    updateProgress(progressInfo);
                }, false);

                return Status.OK;
            } catch (error) {
                return new ResponseResult(UpdateErrorCode.CannotProcessUpdate, `Cannot process update, error: ${error}`)
            }
        }
        else {
            return new ResponseResult(UpdateErrorCode.UnsupportedApiVersion, `Cannot install update! Unsupported API version: ${this._apiVersion}`);
        }
    }

    async InstalUpdateBulkAsync<T extends ICustomUpdateActions>(deviceGuids: string[], updateProgress: UpdateProgress, updateAction?: UpdateAction<T>): Promise<BulkUpdateResult | ResponseResult<UpdateErrorCode>> {
        const resultPromise = new Promise<BulkUpdateResult | ResponseResult<UpdateErrorCode>>(async (resolve, reject) => {
            try {
                await this._connection.SendAndHandleResponseAsync<BulkFirmwareUpgradeStatus | BulkUpdateResult>(new UpgradeFirmwareVersionBulk(deviceGuids), 60000, (resp) => {
                    const progressInfo = new UpdateProgressInfo();

                    switch (resp.Status) {
                        case Status.MultiDataResponseStart: {
                            return;
                        }
                        case Status.MultiDataResponse: {
                            const data = resp.Data as BulkFirmwareUpgradeStatus;
                            const dev = Api.Get<IDevicesService>(DevicesService.ServiceName).GetDevice(data?.DeviceGuid ?? "");
                            progressInfo.UpdatedResourceName = new Map<string, string>([["pl-PL", (dev?.Name ? dev.Name : "n/a")], ["en-US", (dev?.Name ? dev.Name : "n/a")]]);

                            switch (data?.Status) {
                                case FirmwareUpgradeStatus.Error:
                                    progressInfo.Status = UpdateStatus.InstallationError;
                                    break;
                                case FirmwareUpgradeStatus.OK:
                                    progressInfo.Status = UpdateStatus.OK;
                                    break;
                                case FirmwareUpgradeStatus.PreparingForUpgrade:
                                case FirmwareUpgradeStatus.UnpairingRetransmitters:
                                    progressInfo.Status = UpdateStatus.PreparingForUpgrade;
                                    break;
                                case FirmwareUpgradeStatus.Upgraded:
                                    progressInfo.Status = UpdateStatus.Upgraded;
                                    break;
                                case FirmwareUpgradeStatus.DownloadingFirmware:
                                    progressInfo.Status = UpdateStatus.DownloadingPackage;
                                    break;
                                case FirmwareUpgradeStatus.Upgrading:
                                    progressInfo.Status = UpdateStatus.Upgrading;
                                    break;
                                case FirmwareUpgradeStatus.CheckingVersionsOfUpdatedDevices:
                                case FirmwareUpgradeStatus.PairingRetransmitters:
                                    progressInfo.Status = UpdateStatus.Reloading;
                                    break;
                            }

                            progressInfo.Percentage = (data?.DeviceUpdatePercentage ?? 0) as unknown as ProgresPercent;
                            progressInfo.PercentageTotal = data?.TotalUpdatePercentage as unknown as ProgresPercent;
                            progressInfo.AvailableUpdates = data?.DevicesToUpdate ?? 0;
                            progressInfo.UpdateNumber = data?.CurrentDeviceUpdate ?? 0;

                            this._logger.Debug(ExtaLifeDevicesUpdatesProvider.ProviderName, `Recived update progress response, percentage: ${progressInfo.Percentage}, status: ${progressInfo.Status}, resource name: ${dev?.Name}`);
                            break;
                        }
                        case Status.MultiDataResponseStop: {
                            const data = resp.Data as BulkUpdateResult;
                            const result = new BulkUpdateResult();
                            result.BulkUpdateStatus = data.BulkUpdateStatus;
                            result.DevicesUpdateResults = ParseObjToMap<string, BulkUpdateDeviceStatus>(data.DevicesUpdateResults);

                            resolve(result);
                            return;
                        }
                        case Status.Error:
                            reject(new ResponseResult(UpdateErrorCode.CannotFindDevice, `Cannot process update, recived error response.`));
                            return;

                        default:
                            reject(new ResponseResult(UpdateErrorCode.CannotProcessUpdate, `Cannot process update, recived unsupported response status: ${resp.Status}.`));
                            return;
                    }
                    updateProgress(progressInfo);
                }, true);
            } catch (error) {
                reject(new ResponseResult(UpdateErrorCode.CannotProcessUpdate, `Cannot process update, error: ${error}`));
            }
        });

        return resultPromise;
    }
}

class CheckUpdatesRequest extends DataFrame<boolean | null> {
    constructor(reloadCache?: boolean) {
        super();
        this.Resource = "/extalife/device/firmware/upgrade/check";
        this.Method = Method.Put;
        this.Data = reloadCache;
    }
}

class GetFirmwareVersion extends DataFrame<string> {
    constructor(data: string) {
        super();
        this.Resource = "/extalife/device/firmware/version/complete";
        this.Method = Method.Get;
        this.Data = data;
    }
}

class UpgradeFirmwareVersion extends DataFrame<DeviceFirmware> {
    constructor(data: DeviceFirmware) {
        super();
        this.Resource = "/extalife/device/firmware/upgrade";
        this.Method = Method.Put;
        this.Data = data;
    }
}

class UpgradeFirmwareVersionBulk extends DataFrame<string[]> {
    constructor(devGuids: string[]) {
        super();
        this.Resource = "/extalife/device/firmware/upgrade/bulk";
        this.Method = Method.Put;
        this.Data = devGuids;
    }
}


class BulkFirmwareUpgradeStatus {
    DevicesToUpdate: number = 0;
    CurrentDeviceUpdate: number = 0;
    DeviceGuid: string = "";
    Status: FirmwareUpgradeStatus = FirmwareUpgradeStatus.Error;
    DeviceUpdatePercentage: number = 0;
    TotalUpdatePercentage: number = 0;
}

class FirmwareVersion {
    Revision: number = 0;
    Build: number = 0;
    Minor: number = 0;
    Major: number = 0;
}

class DeviceFirmware {
    constructor(deviceGuid: string, uri: string) {
        this.DeviceGuid = deviceGuid;
        this.Uri = uri;
    }
    DeviceGuid: string;
    Uri: string;
}

class Progress {
    CurrentProgress: ProgresPercent = 0;
    FirmwareUpgradeStatus: FirmwareUpgradeStatus = FirmwareUpgradeStatus.Error;
}

enum FirmwareUpgradeStatus {
    Error = -1,
    OK = 0,
    Upgrading = 1,
    PreparingForUpgrade = 2,
    Upgraded = 3,
    DownloadingFirmware = 4,
    UnpairingRetransmitters = 5,
    PairingRetransmitters = 6,
    CheckingVersionsOfUpdatedDevices = 7,
}

export declare class FirmwareUpdate {
    UpdateGuid: string;
    Branch: string;
    Version: FirmwareVersion;
    RequiredMinimumControllerSoftwareVersion: FirmwareVersion;
    DownloadUri: string;
    Name: { [key: string]: string };
    Description: { [key: string]: string };
    PublicationDateTime: string;
}

class UpdateInfoResponse {
    DeviceGuid: string = "";
    IsAvailable: boolean = false;
    NewVersion: string = "";
    CurrentVersion: string = "";
    FirmwareUpdate: FirmwareUpdateResponse = new FirmwareUpdateResponse();
}

class FirmwareUpdateResponse {
    UpdateGuid: string = "";
    Branch: string = "";
    DownloadUri: string = "";
    Name: Map<string, string> = new Map<string, string>();
    Description: Map<string, string> = new Map<string, string>();
    PublicationDateTime: string = "";
}